module.exports = __webpack_public_path__ + "img/prg-logo.14b0b47b.png";